// /**
//  * Store Redirect Popup
//  * Auto-opens on page load, with optional auto-close timer.
//  */
// (function () {
//   const overlay = document.getElementById('StoreRedirectOverlay');
//   if (!overlay) return;

//   const STORAGE_KEY = 'store_redirect_dismissed';
//   const showOnce = overlay.dataset.showOnce === 'true';
//   const autoCloseSeconds = parseInt(overlay.dataset.autoClose, 10) || 0;
//   const delaySeconds = parseInt(overlay.dataset.delay, 10) || 0;

//   // If "show once per session" is enabled, check sessionStorage
//   if (showOnce && sessionStorage.getItem(STORAGE_KEY)) return;

//   const selectEl = overlay.querySelector('.store-redirect-popup__select');
//   const btn = overlay.querySelector('.store-redirect-popup__button');
//   const closeBtn = overlay.querySelector('.store-redirect-popup__close');
//   const timerEl = overlay.querySelector('.store-redirect-popup__timer');

//   let countdownInterval = null;

//   function openPopup() {
//     overlay.classList.add('is-open');
//     document.body.style.overflow = 'hidden';

//     if (autoCloseSeconds > 0) {
//       startCountdown(autoCloseSeconds);
//     }
//   }

//   function closePopup() {
//     overlay.classList.remove('is-open');
//     document.body.style.overflow = '';
//     if (showOnce) {
//       sessionStorage.setItem(STORAGE_KEY, '1');
//     }
//     if (countdownInterval) {
//       clearInterval(countdownInterval);
//       countdownInterval = null;
//     }
//   }

//   function startCountdown(seconds) {
//     let remaining = seconds;
//     updateTimerText(remaining);
//     if (timerEl) timerEl.style.display = '';

//     countdownInterval = setInterval(function () {
//       remaining--;
//       updateTimerText(remaining);
//       if (remaining <= 0) {
//         clearInterval(countdownInterval);
//         countdownInterval = null;
//         closePopup();
//       }
//     }, 1000);
//   }

//   function updateTimerText(sec) {
//     if (!timerEl) return;
//     timerEl.textContent = 'Auto-closing in ' + sec + 's';
//   }

//   // Event listeners
//   closeBtn.addEventListener('click', closePopup);

//   overlay.addEventListener('click', function (e) {
//     if (e.target === overlay) closePopup();
//   });

//   document.addEventListener('keydown', function (e) {
//     if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
//       closePopup();
//     }
//   });

//   // Disable button until a location is selected
//   if (btn) btn.disabled = true;
//   if (selectEl) {
//     selectEl.addEventListener('change', function () {
//       btn.disabled = !this.value;
//     });
//   }

//   btn.addEventListener('click', function () {
//     var url = selectEl ? selectEl.value : '';
//     if (url) {
//       if (showOnce) sessionStorage.setItem(STORAGE_KEY, '1');
//       window.location.href = url;
//     }
//   });

//   // Open with optional delay
//   if (delaySeconds > 0) {
//     setTimeout(openPopup, delaySeconds * 1000);
//   } else {
//     // Small delay to let the page render first
//     setTimeout(openPopup, 300);
//   }
// })();


// (function () {
//   const overlay = document.getElementById('StoreRedirectOverlay');
//   if (!overlay) return;

//   const STORAGE_KEY = 'popup_time';
//   const COUNTRY_KEY = 'last_country';

//   const autoCloseSeconds = parseInt(overlay.dataset.autoClose, 10) || 0;
//   const delaySeconds = parseInt(overlay.dataset.delay, 10) || 0;

//   const selectEl = overlay.querySelector('.store-redirect-popup__select');
//   const btn = overlay.querySelector('.store-redirect-popup__button');
//   const closeBtn = overlay.querySelector('.store-redirect-popup__close');
//   const timerEl = overlay.querySelector('.store-redirect-popup__timer');

//   let countdownInterval = null;

//   const COOLDOWN = 10 * 60 * 1000;

//   function openPopup() {
//     overlay.classList.add('is-open');
//     document.body.style.overflow = 'hidden';

//     localStorage.setItem(STORAGE_KEY, Date.now());

//     if (autoCloseSeconds > 0) {
//       startCountdown(autoCloseSeconds);
//     }
//   }

//   function closePopup() {
//     overlay.classList.remove('is-open');
//     document.body.style.overflow = '';

//     if (countdownInterval) {
//       clearInterval(countdownInterval);
//       countdownInterval = null;
//     }
//   }

//   function startCountdown(seconds) {
//     let remaining = seconds;
//     updateTimerText(remaining);
//     if (timerEl) timerEl.style.display = '';

//     countdownInterval = setInterval(function () {
//       remaining--;
//       updateTimerText(remaining);
//       if (remaining <= 0) {
//         clearInterval(countdownInterval);
//         countdownInterval = null;
//         closePopup();
//       }
//     }, 1000);
//   }

//   function updateTimerText(sec) {
//     if (!timerEl) return;
//     timerEl.textContent = 'Auto-closing in ' + sec + 's';
//   }

//   if (closeBtn) closeBtn.addEventListener('click', closePopup);

//   overlay.addEventListener('click', function (e) {
//     if (e.target === overlay) closePopup();
//   });

//   document.addEventListener('keydown', function (e) {
//     if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
//       closePopup();
//     }
//   });

//   if (btn) btn.disabled = true;

//   if (selectEl) {
//     selectEl.addEventListener('change', function () {
//       btn.disabled = !this.value;
//     });
//   }

//   if (btn) {
//     btn.addEventListener('click', function () {
//       var url = selectEl ? selectEl.value : '';
//       if (url) {
//         window.location.href = url;
//       }
//     });
//   }

//   function checkGeoAndShow() {
//     fetch("https://ipapi.co/json/")
//       .then(res => res.json())
//       .then(data => {
//         const currentCountry = data.country;

//         if (currentCountry === "US" || currentCountry === "CA") {
//           console.log("Popup blocked for US/CA");
//           return;
//         }

//         const lastCountry = localStorage.getItem(COUNTRY_KEY);
//         const lastShown = localStorage.getItem(STORAGE_KEY);

//         const now = Date.now();

//         let shouldShow = false;

//         if (lastCountry !== currentCountry) {
//           shouldShow = true;
//         }

//         if (!lastShown || (now - lastShown > COOLDOWN)) {
//           shouldShow = true;
//         }

//         if (shouldShow) {
//           if (delaySeconds > 0) {
//             setTimeout(openPopup, delaySeconds * 1000);
//           } else {
//             setTimeout(openPopup, 300);
//           }
//         }

//         localStorage.setItem(COUNTRY_KEY, currentCountry);
//       })
//       .catch(() => {
//         setTimeout(openPopup, 300);
//       });
//   }

//   document.addEventListener("DOMContentLoaded", checkGeoAndShow);

// })();





// (function () {
//   const overlay = document.getElementById("StoreRedirectOverlay");
//   if (!overlay) return;

//   const STORAGE_KEY = "popup_time";
//   const COUNTRY_KEY = "last_country";

//   const autoCloseSeconds = parseInt(overlay.dataset.autoClose, 10) || 0;
//   const delaySeconds = parseInt(overlay.dataset.delay, 10) || 0;

//   const selectEl = overlay.querySelector(".store-redirect-popup__select");
//   const btn = overlay.querySelector(".store-redirect-popup__button");
//   const closeBtn = overlay.querySelector(".store-redirect-popup__close");
//   const timerEl = overlay.querySelector(".store-redirect-popup__timer");

//   const COOLDOWN = 10 * 60 * 1000;

//   let countdownInterval = null;

//   function openPopup() {
//     overlay.classList.add("is-open");
//     document.body.style.overflow = "hidden";

//     localStorage.setItem(STORAGE_KEY, Date.now());

//     if (autoCloseSeconds > 0) {
//       startCountdown(autoCloseSeconds);
//     }
//   }

//   function closePopup() {
//     overlay.classList.remove("is-open");
//     document.body.style.overflow = "";

//     if (countdownInterval) {
//       clearInterval(countdownInterval);
//       countdownInterval = null;
//     }
//   }

//   function startCountdown(seconds) {
//     let remaining = seconds;

//     updateTimer(remaining);

//     if (timerEl) timerEl.style.display = "";

//     countdownInterval = setInterval(function () {
//       remaining--;

//       updateTimer(remaining);

//       if (remaining <= 0) {
//         clearInterval(countdownInterval);
//         countdownInterval = null;
//         closePopup();
//       }
//     }, 1000);
//   }

//   function updateTimer(sec) {
//     if (!timerEl) return;
//     timerEl.textContent = "Auto-closing in " + sec + "s";
//   }

//   if (closeBtn) {
//     closeBtn.addEventListener("click", closePopup);
//   }

//   overlay.addEventListener("click", function (e) {
//     if (e.target === overlay) {
//       closePopup();
//     }
//   });

//   document.addEventListener("keydown", function (e) {
//     if (e.key === "Escape") {
//       closePopup();
//     }
//   });

//   if (btn) {
//     btn.disabled = true;
//   }

//   if (selectEl) {
//     selectEl.addEventListener("change", function () {
//       btn.disabled = !this.value;
//     });
//   }

//   if (btn) {
//     btn.addEventListener("click", function () {
//       if (selectEl && selectEl.value) {
//         window.location.href = selectEl.value;
//       }
//     });
//   }

//   function checkGeoAndShow() {

//     fetch("https://ipapi.co/json/")
//       .then(function (res) {
//         return res.json();
//       })
//       .then(function (data) {

//         const ipCountry = data.country || "";
//         const localizationCountry = window.shopifyLocalizationCountry || "";

//         // Block if either IP OR View As is US/CA
//         if (
//           ipCountry === "US" ||
//           ipCountry === "CA" ||
//           localizationCountry === "US" ||
//           localizationCountry === "CA"
//         ) {
//           console.log("Popup blocked (US/CA)");
//           return;
//         }

//         // Use Shopify country if available otherwise IP
//         const currentCountry = localizationCountry || ipCountry;

//         const lastCountry = localStorage.getItem(COUNTRY_KEY);
//         let lastShown = localStorage.getItem(STORAGE_KEY);

//         const now = Date.now();

//         // Country changed
//         if (lastCountry && lastCountry !== currentCountry) {

//           console.log(
//             "Country Changed:",
//             lastCountry,
//             "→",
//             currentCountry
//           );

//           localStorage.removeItem(STORAGE_KEY);

//           lastShown = null;
//         }

//         let shouldShow = false;

//         if (!lastShown) {

//           shouldShow = true;

//         } else if (now - Number(lastShown) >= COOLDOWN) {

//           shouldShow = true;

//         }

//         if (shouldShow) {

//           setTimeout(function () {

//             openPopup();

//           }, delaySeconds > 0 ? delaySeconds * 1000 : 300);

//         }

//         localStorage.setItem(COUNTRY_KEY, currentCountry);

//       })
//       .catch(function () {

//         // API failed

//         const localizationCountry =
//           window.shopifyLocalizationCountry || "";

//         if (
//           localizationCountry === "US" ||
//           localizationCountry === "CA"
//         ) {
//           return;
//         }

//         const currentCountry = localizationCountry;

//         const lastCountry = localStorage.getItem(COUNTRY_KEY);

//         if (lastCountry && lastCountry !== currentCountry) {

//           localStorage.removeItem(STORAGE_KEY);

//         }

//         localStorage.setItem(COUNTRY_KEY, currentCountry);

//         const lastShown = localStorage.getItem(STORAGE_KEY);

//         if (!lastShown) {

//           setTimeout(function () {

//             openPopup();

//           }, delaySeconds > 0 ? delaySeconds * 1000 : 300);

//         }

//       });

//   }

//   document.addEventListener("DOMContentLoaded", checkGeoAndShow);

// })();


// (function () {
//   const overlay = document.getElementById("StoreRedirectOverlay");
//   if (!overlay) return;

//   const STORAGE_KEY = "popup_time";
//   const IP_COUNTRY_KEY = "last_ip_country";
//   const LOCALIZATION_COUNTRY_KEY = "last_localization_country";

//   const autoCloseSeconds = parseInt(overlay.dataset.autoClose, 10) || 0;
//   const delaySeconds = parseInt(overlay.dataset.delay, 10) || 0;

//   const selectEl = overlay.querySelector(".store-redirect-popup__select");
//   const btn = overlay.querySelector(".store-redirect-popup__button");
//   const closeBtn = overlay.querySelector(".store-redirect-popup__close");
//   const timerEl = overlay.querySelector(".store-redirect-popup__timer");

//   const COOLDOWN = 10 * 60 * 1000; // 10 minutes

//   let countdownInterval = null;

//   function openPopup() {
//     overlay.classList.add("is-open");
//     document.body.style.overflow = "hidden";
//     localStorage.setItem(STORAGE_KEY, Date.now());

//     if (autoCloseSeconds > 0) {
//       startCountdown(autoCloseSeconds);
//     }
//   }

//   function closePopup() {
//     overlay.classList.remove("is-open");
//     document.body.style.overflow = "";

//     if (countdownInterval) {
//       clearInterval(countdownInterval);
//       countdownInterval = null;
//     }
//   }

//   function startCountdown(seconds) {
//     let remaining = seconds;
//     updateTimer(remaining);
//     if (timerEl) timerEl.style.display = "";

//     countdownInterval = setInterval(function () {
//       remaining--;
//       updateTimer(remaining);
//       if (remaining <= 0) {
//         clearInterval(countdownInterval);
//         countdownInterval = null;
//         closePopup();
//       }
//     }, 1000);
//   }

//   function updateTimer(sec) {
//     if (!timerEl) return;
//     timerEl.textContent = "Auto-closing in " + sec + "s";
//   }

//   if (closeBtn) {
//     closeBtn.addEventListener("click", closePopup);
//   }

//   overlay.addEventListener("click", function (e) {
//     if (e.target === overlay) closePopup();
//   });

//   document.addEventListener("keydown", function (e) {
//     if (e.key === "Escape") closePopup();
//   });

//   if (btn) btn.disabled = true;

//   if (selectEl) {
//     selectEl.addEventListener("change", function () {
//       btn.disabled = !this.value;
//     });
//   }

//   if (btn) {
//     btn.addEventListener("click", function () {
//       if (selectEl && selectEl.value) {
//         window.location.href = selectEl.value;
//       }
//     });
//   }

//   function isBlocked(ipCountry, localizationCountry) {
//     return (
//       ipCountry === "US" ||
//       ipCountry === "CA" ||
//       localizationCountry === "US" ||
//       localizationCountry === "CA"
//     );
//   }

//   function evaluateAndShow(ipCountry, localizationCountry) {
//     if (isBlocked(ipCountry, localizationCountry)) {
//       console.log("Popup blocked (US/CA)");
//       if (ipCountry) localStorage.setItem(IP_COUNTRY_KEY, ipCountry);
//       localStorage.setItem(LOCALIZATION_COUNTRY_KEY, localizationCountry);
//       return;
//     }

//     const lastIpCountry = localStorage.getItem(IP_COUNTRY_KEY);
//     const lastLocalizationCountry = localStorage.getItem(LOCALIZATION_COUNTRY_KEY);

//     // ★ MAIN FIX ★
   
//     const ipChanged =
//       lastIpCountry !== null &&
//       ipCountry !== "" &&
//       lastIpCountry !== ipCountry;

//     const localizationChanged =
//       lastLocalizationCountry !== null &&
//       lastLocalizationCountry !== localizationCountry;

//     if (ipChanged || localizationChanged) {
//       console.log("Country changed:", {
//         ip: lastIpCountry + " -> " + ipCountry,
//         localization: lastLocalizationCountry + " -> " + localizationCountry,
//       });
//       localStorage.removeItem(STORAGE_KEY);
//     }

//     const lastShown = localStorage.getItem(STORAGE_KEY);
//     const now = Date.now();

//     let shouldShow = false;
//     if (!lastShown) {
//       shouldShow = true;
//     } else if (now - Number(lastShown) >= COOLDOWN) {
//       shouldShow = true;
//     }

//     if (shouldShow) {
//       setTimeout(openPopup, delaySeconds > 0 ? delaySeconds * 1000 : 300);
//     }

//     if (ipCountry) localStorage.setItem(IP_COUNTRY_KEY, ipCountry);
//     localStorage.setItem(LOCALIZATION_COUNTRY_KEY, localizationCountry);
//   }

//   function checkGeoAndShow() {
//     const localizationCountry = window.shopifyLocalizationCountry || "";

//     fetch("https://ipapi.co/json/")
//       .then(function (res) {
//         return res.json();
//       })
//       .then(function (data) {
//         const ipCountry =
//           data && data.country && !data.error ? data.country : "";
//         evaluateAndShow(ipCountry, localizationCountry);
//       })
//       .catch(function () {
//         evaluateAndShow("", localizationCountry);
//       });
//   }

//   document.addEventListener("DOMContentLoaded", checkGeoAndShow);
// })();



(function () {
  const overlay = document.getElementById("StoreRedirectOverlay");
  if (!overlay) return;

  // ---- Storage keys ----
  const SESSION_KEY = "store_redirect_popup_shown"; // NEW: session-based
  const STORAGE_KEY = "popup_time";                 // OLD: 10-min cooldown
  const IP_COUNTRY_KEY = "last_ip_country";
  const LOCALIZATION_COUNTRY_KEY = "last_localization_country";

  const COOLDOWN = 10 * 60 * 1000; // 10 minutes (used only when show_once is OFF)

  const autoCloseSeconds = parseInt(overlay.dataset.autoClose, 10) || 0;
  const delaySeconds = parseInt(overlay.dataset.delay, 10) || 0;
  // Read the "Show only once per session" setting from Liquid data attribute
  const showOnce = overlay.dataset.showOnce === "true";

  const selectEl = overlay.querySelector(".store-redirect-popup__select");
  const btn = overlay.querySelector(".store-redirect-popup__button");
  const closeBtn = overlay.querySelector(".store-redirect-popup__close");
  const timerEl = overlay.querySelector(".store-redirect-popup__timer");

  let countdownInterval = null;

  function openPopup() {
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";

    // Mark popup as shown — different storage based on setting
    if (showOnce) {
      // NEW: sessionStorage — clears when browser/tab closes
      sessionStorage.setItem(SESSION_KEY, "1");
    } else {
      // OLD: localStorage timestamp — used for 10-min cooldown
      localStorage.setItem(STORAGE_KEY, Date.now());
    }

    if (autoCloseSeconds > 0) {
      startCountdown(autoCloseSeconds);
    }
  }

  function closePopup() {
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";

    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  }

  function startCountdown(seconds) {
    let remaining = seconds;
    updateTimer(remaining);
    if (timerEl) timerEl.style.display = "";

    countdownInterval = setInterval(function () {
      remaining--;
      updateTimer(remaining);
      if (remaining <= 0) {
        clearInterval(countdownInterval);
        countdownInterval = null;
        closePopup();
      }
    }, 1000);
  }

  function updateTimer(sec) {
    if (!timerEl) return;
    timerEl.textContent = "Auto-closing in " + sec + "s";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePopup();
  });

  if (btn) btn.disabled = true;

  if (selectEl) {
    selectEl.addEventListener("change", function () {
      btn.disabled = !this.value;
    });
  }

  if (btn) {
    btn.addEventListener("click", function () {
      if (selectEl && selectEl.value) {
        window.location.href = selectEl.value;
      }
    });
  }

  function isBlocked(ipCountry, localizationCountry) {
    return (
      ipCountry === "US" ||
      ipCountry === "CA" ||
      localizationCountry === "US" ||
      localizationCountry === "CA"
    );
  }

  function evaluateAndShow(ipCountry, localizationCountry) {
    // 1. US / CA exclusion — never show for these regions
    if (isBlocked(ipCountry, localizationCountry)) {
      console.log("Popup blocked (US/CA region)");
      if (ipCountry) localStorage.setItem(IP_COUNTRY_KEY, ipCountry);
      localStorage.setItem(LOCALIZATION_COUNTRY_KEY, localizationCountry);
      return;
    }

    // 2. Branch based on show_once setting
    if (showOnce) {
      // ===== NEW BEHAVIOUR: Once per session =====
      if (sessionStorage.getItem(SESSION_KEY)) {
        console.log("Popup already shown this session — skipping");
        return;
      }

      setTimeout(openPopup, delaySeconds > 0 ? delaySeconds * 1000 : 300);
    } else {
      // ===== OLD BEHAVIOUR: 10-min cooldown + country change detection =====
      const lastIpCountry = localStorage.getItem(IP_COUNTRY_KEY);
      const lastLocalizationCountry = localStorage.getItem(LOCALIZATION_COUNTRY_KEY);

      const ipChanged =
        lastIpCountry !== null &&
        ipCountry !== "" &&
        lastIpCountry !== ipCountry;

      const localizationChanged =
        lastLocalizationCountry !== null &&
        lastLocalizationCountry !== localizationCountry;

      if (ipChanged || localizationChanged) {
        console.log("Country changed:", {
          ip: lastIpCountry + " -> " + ipCountry,
          localization: lastLocalizationCountry + " -> " + localizationCountry,
        });
        localStorage.removeItem(STORAGE_KEY);
      }

      const lastShown = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();

      let shouldShow = false;
      if (!lastShown) {
        shouldShow = true;
      } else if (now - Number(lastShown) >= COOLDOWN) {
        shouldShow = true;
      }

      if (shouldShow) {
        setTimeout(openPopup, delaySeconds > 0 ? delaySeconds * 1000 : 300);
      }

      if (ipCountry) localStorage.setItem(IP_COUNTRY_KEY, ipCountry);
      localStorage.setItem(LOCALIZATION_COUNTRY_KEY, localizationCountry);
    }
  }

  function checkGeoAndShow() {
    const localizationCountry = window.shopifyLocalizationCountry || "";

    fetch("https://ipapi.co/json/")
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        const ipCountry =
          data && data.country && !data.error ? data.country : "";
        evaluateAndShow(ipCountry, localizationCountry);
      })
      .catch(function () {
        evaluateAndShow("", localizationCountry);
      });
  }

  document.addEventListener("DOMContentLoaded", checkGeoAndShow);
})();